// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__zQoKU","alert":"SettungsInbox_alert__2iUUo"};